<template>
  <div class="app-container work-log-home">
    <div class="work-log-shell">
      <div class="work-log-head">
        <div>
          <div class="work-log-title">工作日志</div>
          <div class="work-log-subtitle">写日志、查看收到的日志，并维护日志模板</div>
        </div>
      </div>

      <el-tabs v-if="visibleTabs.length" v-model="activeTab" class="work-log-tabs">
        <el-tab-pane v-for="tab in visibleTabs" :key="tab.name" :label="tab.label" :name="tab.name" />
      </el-tabs>

      <div v-if="activeComponent" class="work-log-content">
        <keep-alive>
          <component :is="activeComponent" />
        </keep-alive>
      </div>
      <el-empty v-else description="暂无工作日志权限" />
    </div>
  </div>
</template>

<script>
import WorkLogMy from './my'
import WorkLogReceived from './received'
import WorkLogTemplate from './template'

export default {
  name: 'WorkLogIndex',
  components: {
    WorkLogMy,
    WorkLogReceived,
    WorkLogTemplate
  },
  data() {
    return {
      activeTab: 'my'
    }
  },
  computed: {
    visibleTabs() {
      return [
        { name: 'my', label: '我的日志', component: 'WorkLogMy', perms: ['crm:workLog:list'] },
        { name: 'received', label: '我收到的', component: 'WorkLogReceived', perms: ['crm:workLog:received', 'crm:workLog:viewAll'] },
        { name: 'template', label: '模板配置', component: 'WorkLogTemplate', perms: ['crm:workLogTemplate:list'] }
      ].filter(tab => this.hasAnyPermission(tab.perms))
    },
    activeComponent() {
      const tab = this.visibleTabs.find(item => item.name === this.activeTab) || this.visibleTabs[0]
      return tab ? tab.component : ''
    }
  },
  watch: {
    visibleTabs: {
      immediate: true,
      handler(tabs) {
        if (!tabs.length) {
          this.activeTab = ''
          return
        }
        const queryTab = this.$route && this.$route.query && this.$route.query.tab
        const nextTab = tabs.find(item => item.name === queryTab) || tabs.find(item => item.name === this.activeTab) || tabs[0]
        this.activeTab = nextTab.name
      }
    },
    activeTab(tab) {
      if (!tab || !this.$route) return
      if (this.$route.query && this.$route.query.tab === tab) return
      this.$router.replace({ path: this.$route.path, query: { ...this.$route.query, tab } })
    }
  },
  methods: {
    hasAnyPermission(values) {
      const permissions = (this.$store && this.$store.getters && this.$store.getters.permissions) || []
      if (permissions.includes('*:*:*')) {
        return true
      }
      return values.some(item => permissions.includes(item))
    }
  }
}
</script>

<style scoped>
.work-log-home {
  min-height: calc(100vh - 84px);
  background: #f4f6fa;
}

.work-log-shell {
  background: #fff;
  border: 1px solid #edf0f5;
  border-radius: 6px;
}

.work-log-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px 12px;
  border-bottom: 1px solid #edf0f5;
}

.work-log-title {
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
  line-height: 28px;
}

.work-log-subtitle {
  margin-top: 4px;
  font-size: 13px;
  color: #8a95a6;
}

.work-log-tabs {
  padding: 0 20px;
}

.work-log-tabs ::v-deep .el-tabs__header {
  margin: 0;
}

.work-log-tabs ::v-deep .el-tabs__nav-wrap::after {
  height: 1px;
  background-color: #edf0f5;
}

.work-log-content ::v-deep .app-container {
  padding: 16px 20px 20px;
}
</style>
